import { useFlow } from '../../common/providers/FlowProvider';
import SelectRadioInputSheet from '../../common/sheets/SelectRadioInputSheet';
import type { Income } from '../types/Income';
import {
    getIncomeOwnerDisplayFormatter,
    getIncomeOwnerOptionsMap,
} from '../utils/incomeUtils';

interface IncomeOwnerSelectionSheetProps {
    isOpen: boolean;
    onClose: () => void;
    selectedOption: string;
    onSelectOption: (belongsToUserId: string | null) => void;
}

const IncomeOwnerSelectionSheet = ({
    isOpen,
    onClose,
    selectedOption,
    onSelectOption,
}: IncomeOwnerSelectionSheetProps) => {
    const { membership, logger } = useFlow<Income>();
    const { users } = membership;

    const options = getIncomeOwnerOptionsMap(users);
    const formatIncomeOwner = getIncomeOwnerDisplayFormatter(users, logger);

    return (
        <SelectRadioInputSheet
            title="Income owner"
            options={options}
            selectedOption={selectedOption}
            onSelectOption={onSelectOption}
            isOpen={isOpen}
            onClose={onClose}
            toLabelFn={formatIncomeOwner}
        />
    );
};

export default IncomeOwnerSelectionSheet;
